import { render, staticRenderFns } from "./CompanyForm.vue?vue&type=template&id=b3ca8d96&scoped=true"
import script from "./CompanyForm.vue?vue&type=script&lang=js"
export * from "./CompanyForm.vue?vue&type=script&lang=js"
import style0 from "./CompanyForm.vue?vue&type=style&index=0&id=b3ca8d96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ca8d96",
  null
  
)

export default component.exports